import { render } from "./ListaPostagens.vue?vue&type=template&id=1c792f2c&scoped=true"
import script from "./ListaPostagens.vue?vue&type=script&lang=js"
export * from "./ListaPostagens.vue?vue&type=script&lang=js"

import "./ListaPostagens.vue?vue&type=style&index=0&id=1c792f2c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c792f2c"]])

export default __exports__